import "./app/ceres/publicPath";
import Vue from "vue";
import Vuex from "vuex";
import NotificationService from "./app/ceres/services/NotificationService";
import TranslationService from "./app/ceres/services/TranslationService";
import "bootstrap";
import "owl.carousel";
import { createApp, beforeCreate } from "./ssr-checkout";
import "custom-event-polyfill";
import { initClientListeners, initClientStore, createStore } from "./app/eros/store/checkout";
import { initListener } from "./app/ceres/services/ApiService";
import { mount } from "./mount";
import "./app/eros/plugins/jQuery";

Vue.prototype.$mount = mount;
if (App.Eros.Config.general.benchmarkJS) {
	Vue.config.performance = true;
}

// defines if the render location is the client
App.isSSR = false;
App.isSSREnabled = App.config.log.performanceSsr;

beforeCreate();

window.createApp = (selector) => {
    // client-specific bootstrapping logic...
    const app = createApp({
        template: "#ssr-script-container"
    }, store);

	if (window.__INITIAL_STATE__) {
		store.replaceState(window.__INITIAL_STATE__);
	}

    app.$mount(selector, true);
    window.vueApp = app;

    initListener();
    initClientListeners(store);
    initClientStore(store);
};

const store = createStore();

if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__);
}

window.Vue = Vue;
window.Vuex = Vuex;
window.NotificationService = NotificationService;
window.ceresTranslate = TranslationService.translate;
window.vueEventHub = new Vue();
window.ceresStore = store;

// =========================
// Common
// =========================
import "./app/eros/common/carouselMobileCheck";
import "./app/eros/common/mobileStickyButtons";
import "./app/eros/common/registerMutationObserver";

// =========================
// External Plugins
// =========================
import "./app/eros/plugins/external/svbadge";
import "./app/eros/plugins/external/magiczoomplus";

// =========================
// Landing
// =========================
// import "./app/eros/common/landing/sideNavi";
// import "./app/eros/common/landing/smoothScroll";

import "./app/eros/main";
